import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef, lazy, Suspense } from "react";
import { Button } from "@mantine/core";
import { useAuth } from "./AuthContext";
import { PrivySignInButton } from "./providers/privy/PrivySignInButton";
const FarcasterSignInButton = lazy(() => import("./providers/farcaster/signin").then((mod) => ({
    default: mod.FarcasterSignInButton,
})));
export const SignInButton = forwardRef((props, ref) => {
    const { mode } = useAuth();
    if (mode === "farcaster") {
        return (_jsx(Suspense, { fallback: _jsx(Button, { ...props, ref: ref, loading: true }), children: _jsx(FarcasterSignInButton, { ...props, ref: ref, children: "Sign In" }) }));
    }
    return (_jsx(PrivySignInButton, { ...props, ref: ref, children: "Sign In" }));
});
